/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Account')
    .factory('removeAllNotifications', ['confirmAction', '$translate', 'AccountNotificationsShares', 'operationComplete', function (confirmAction, $translate, AccountNotificationsShares, operationComplete) {
        return function(node){
            $translate(["Stop receiving notifications?", "Are you sure you want to stop receiving notifications for '%{share}'?", "Confirm"], {share: node.name}).then(function(strings) {
                confirmAction({}, {
                    confirmTitle: strings["Stop receiving notifications?"],
                    confirmBody: strings["Are you sure you want to stop receiving notifications for '%{share}'?"],
                    confirmSubmit: strings["Confirm"]
                }).then(function () {
                    AccountNotificationsShares.get({uuid: node.uuid}, {}, function (notification) {
                        notification.$delete({uuid: notification.user_uuid + ',' + notification.node_uuid}, function () {
                            operationComplete("notifications_removed_for_share_success_message", {share: node.name});
                        });
                    });
                })
            });
        }
    }]);
